module.exports = __webpack_public_path__ + "img/117.48e09e17.svg";